import { Component, OnInit, ViewChild } from '@angular/core';
import { FiltroRelatorioLotesVsEstoque } from '../filter/filtro-relatorio-lotes-vs-estoque';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoDynamicFormField, PoLookupColumn, PoModalAction, PoModalComponent, PoPageFilter, PoSearchFilterMode, PoSelectOption, PoTableColumn } from '@po-ui/ng-components';
import { Router } from '@angular/router';
import { RomaneioService } from '../service/romaneio.service';
import { PoStorageService } from '@po-ui/ng-storage';
import { ExcelService } from 'src/app/service/excel-service';
import { Cliente } from 'src/app/interface/cliente';
import { ClienteLookupService } from 'src/app/service/cliente-lookup-service';
import { ProdutoLookupService } from 'src/app/service/produto-lookup-service';
import { Produto } from 'src/app/interface/produto';

@Component({
  selector: 'app-relatorio-lotes-vs-estoque',
  templateUrl: './relatorio-lotes-vs-estoque.component.html',
  styleUrls: ['./relatorio-lotes-vs-estoque.component.css']
})
export class RelatorioLotesVsEstoqueComponent implements OnInit {

  tabelaPrincipalItens: Array<any> = [];
  tabelaPrincipalFiltro: FiltroRelatorioLotesVsEstoque;

  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;

  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  advancedClienteFilters: Array<PoDynamicFormField>;
  columnsClienteFilters: Array<PoLookupColumn>;
  fieldFormaterClienteFilters: ((value: Cliente) => string);

  advancedProdutoFilters: Array<PoDynamicFormField>;
  columnsProdutoFilters: Array<PoLookupColumn>;
  fieldFormaterProdutoFilters: ((value: Produto) => string);

  constructor(
    private router: Router,
    private romaneioService: RomaneioService,
    private poStorageService: PoStorageService,
    private excelService: ExcelService,
    public clienteLookupService: ClienteLookupService,
    public produtoLookupService: ProdutoLookupService,
  ) {
    this.tabelaPrincipalFiltro = new FiltroRelatorioLotesVsEstoque(this.poStorageService);

    this.advancedClienteFilters = this.clienteLookupService.getAdvancedFilter();
    this.columnsClienteFilters = this.clienteLookupService.getColumnsFilter();
    this.fieldFormaterClienteFilters = this.clienteLookupService.getFieldFormater;

    this.advancedProdutoFilters = this.produtoLookupService.getAdvancedFilter();
    this.columnsProdutoFilters = this.produtoLookupService.getColumnsFilter();
    this.fieldFormaterProdutoFilters = this.produtoLookupService.getFieldFormater;
  }

  @ViewChild('advancedFilterModal', { static: true }) advancedFilterModal!: PoModalComponent;

  ngOnInit(): void {
  }

  tabelaPrincipalLoad(): void {
    this.romaneioService.listaRelatorioLotesVsEstoque(this.tabelaPrincipalFiltro.dados).subscribe((lista) => {
      this.tabelaPrincipalItens = lista.items;
    });
  }

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [

    
    {property: 'CSF2DOC'       , label: 'NFiscal'         , width: '10%'},
    {property: 'DSF2EMIS'      , label: 'DT Faturamento'  , width: '10%', type: 'date', format: 'dd/MM/yyyy'},
    {property: 'DTCARREGA'     , label: 'DT Carregamento' , width: '10%', type: 'date', format: 'dd/MM/yyyy'},
    {property: 'CZ02LOTE'      , label: 'Lote'            , width: '15%'},
    {property: 'DSD3DTEMISSAO' , label: 'DT Lote'         , width: '10%', type: 'date', format: 'dd/MM/yyyy'},
    {property: 'CB1COD'        , label: 'Produto'         , width: '20%'},
    {property: 'CB1DESC'       , label: 'Descrição'       , width: '20%'},
    {property: 'NB8QTDORI'     , label: 'QTDE'            , width: '7%'},
    {property: 'CB8LOCAL'      , label: 'Local'           , width: '7%'},  
    {property: 'NB8QTDORI2'    , label: 'M3'              , width: '7%'},
    {property: 'CC5PEDEXP'     , label: 'PO'              , width: '15%'},
    {property: 'CC5NUM'        , label: 'Pedido'          , width: '7%'},
    {property: 'NZ02PESO'      , label: 'Peso'            , width: '7%'},
    {property: 'CZ02UR'        , label: 'UR'              , width: '7%'},
    {property: 'CA1NOME'       , label: 'Nome Cliente'    , width: '20%'},
    {property: 'CZ00COD'       , label: 'ROMANEIO CLI'    , width: '7%'}, 
    {property: 'NZ00STATUS'    , label: 'Status'          , width: '20%'},  
       
  ];

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Home', action: this.goHome.bind(this) },
      { label: 'Relatório Lotes Vs Estoque' }
    ]
  };

  gerarExcel(): void {
    const lista_excel = this.tabelaPrincipalItens.map( (item) => {
      return{
        'NFiscal': item.CSF2DOC,
        'DT Faturamento': item.DSF2EMIS ? String(item.DSF2EMIS).split('-').reverse().join('/') : '',
        'DT Carregamento':  item.DTCARREGA ? String(item.DTCARREGA).split('-').reverse().join('/') : '',
        'Lote': item.CZ02LOTE,
        'DT Lote':  item.DSD3DTEMISSAO ? String(item.DSD3DTEMISSAO).split('-').reverse().join('/') : '',
        'Produto': item.CB1COD,
        'Descrição': item.CB1DESC,
        'QTDE': item.NB8QTDORI,
        'Local': item.CB8LOCAL,
        'M3': item.NB8QTDORI2,
        'PO': item.CC5PEDEXP,
        'Pedido': item.CC5NUM,  
        'Peso': item.NZ02PESO,
        'UR': item.CZ02UR,
        'Nome Cliente': item.CA1NOME,
        'ROMANEIO CLI': item.CZ00COD,
        'Status': item.NZ00STATUS,
        }
    });

    this.excelService.exportAsExcelFile(lista_excel, `Relatório Lotes Vs Estoque`);
  }

  goHome(): void {
    this.router.navigateByUrl('');
  }

  //################################################################//
  // FILTRO
  //################################################################//
  public readonly filterSettings: PoPageFilter = {
    advancedAction: this.advancedFilterActionModal.bind(this),
  };

  advancedFilterActionModal(): void {
    this.advancedFilterModal.open();
  }

  public readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.advancedFilterModal.close();
      this.tabelaPrincipalLoad();
    },
    label: 'Aplicar Filtros'
  };
  

  clienteSelecionado(row: Cliente): void {
    this.tabelaPrincipalFiltro.dados.CA1COD = row.CA1COD;
    this.tabelaPrincipalFiltro.dados.CA1LOJA = row.CA1LOJA;
  }

}
